export const Addmetatags = () => {
  const metatages = [
    {
      "http-equiv": "Cache-Control",
      content: "no-cache,no-store,must-revalidate",
    },
    { "http-equiv": "Pragma", content: "no-cache" },
    { "http-equiv": "Expires", content: "0" },
  ];

  metatages.forEach((tagInfo) => {
    const meta = document.createElement("meta");
    Object.keys(tagInfo).forEach((key) => {
      meta.setAttribute(key, tagInfo[key]);
    });
    document.head.appendChild(meta);
  });
};
